export default "__VITE_ASSET__BFnJHyGH__"